export const CATALOGUE_TAGS_LIST = {
  cacheKey: 'CATALOGUE_TAGS_LIST'
};
